import type { ITerm } from "store/managementStore";

import type { IWork } from "./types";

type TermWorkFields = Pick<ITerm, "workId" | "title"> & {
    titleAvatarUrl?: string | null;
    avatarUrl?: string | null;
};

export const coverUrlForWork = (work: IWork | null | undefined): string | undefined =>
    work?.avatarUrl ?? work?.titles?.find((title) => title.avatarUrl)?.avatarUrl ?? undefined;

export const workDisplayLabel = (work: { name: string; workCode?: string | null } | null | undefined): string => {
    const name = work?.name ?? "";
    const workCode = work?.workCode?.trim();
    return workCode ? `${name} (${workCode})` : name;
};

export const workPreviewFromTerm = (
    term: TermWorkFields | null | undefined,
    selectedWork: IWork | null = null,
): IWork | null => {
    if (term?.workId == null) return null;
    if (selectedWork != null && Number(selectedWork.id) === Number(term.workId)) return selectedWork;

    // selectedWork is another work here (the store slot is shared): borrowing its fields would show
    // that work's code, cover and titles under this one's name.
    const name = term.title ?? "";
    if (!name) return null;

    return {
        id: term.workId,
        name,
        workCode: null,
        companyId: 0,
        artworkNature: null,
        analysisCode: null,
        associatedBrand: null,
        compensationGroupId: null,
        avatarUrl: term.titleAvatarUrl ?? term.avatarUrl ?? null,
        createdAt: "",
        updatedAt: "",
        titles: [],
    };
};
